var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferralHowItWorksStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 102,
    viewBox: "0 0 103 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4995 101.347C79.1009 101.347 101.673 78.7747 101.673 51.1733C101.673 23.5279 79.1009 1 51.4995 1C23.8541 1 1.32617 23.5295 1.32617 51.1733C1.32466 78.7747 23.8541 101.347 51.4995 101.347Z",
    fill: "#393E45",
    stroke: "black",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0618 29.6318C42.34 29.8032 61.6024 28.9008 61.8602 29.6318C62.0756 30.3629 61.8178 33.8028 61.1716 34.2321C59.5381 35.3499 58.0336 36.4677 56.9582 37.4991C58.2914 40.0351 60.2692 42.8304 62.4184 45.6682C66.6318 51.3862 78.6701 60.6307 70.5875 70.8201C68.094 73.9157 64.6981 75.5917 60.6984 75.5917H41.1797C37.224 75.5917 33.7841 73.9142 31.3346 70.8201C23.2095 60.6307 35.2902 51.3862 39.5037 45.6682C41.6104 42.8304 43.5882 40.0366 44.9214 37.4991C43.8461 36.4677 42.3415 35.3499 40.7079 34.2321C39.8904 33.6724 39.6326 29.6318 40.0618 29.6318Z",
    fill: "#27282B",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5282 66.3066V70.4352H35.4195V74.5622H33.0549H25.2726H22.6077V70.4352H20.7148V66.3066H33.5282Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0943 62.1348H80.9501V66.3042H82.3682V70.4328H80.4768V74.5598H77.9409H73.8988H70.1586H67.6211V70.4328H69.5139V66.3042H68.0943V62.1348Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9214 34.834H47.9306H50.9398H53.949H56.9582C58.2914 37.37 60.2692 40.1653 62.4184 43.0031C66.6318 48.7211 78.6701 57.9656 70.5875 68.155C68.094 71.2931 64.6981 72.9266 60.6984 72.9266C54.2069 72.9266 47.7137 72.9266 41.1797 72.9266C37.224 72.9266 33.7841 71.2931 31.3346 68.155C23.2095 57.9656 35.2902 48.7211 39.5037 43.0031C41.6104 40.1653 43.5882 37.37 44.9214 34.834Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9198 34.8344H56.958C58.0334 33.803 59.538 32.6852 61.1715 31.5674C61.8161 31.1381 62.074 30.3631 61.8601 29.632C61.6023 28.901 60.9576 28.4277 60.1826 28.4277H41.6952C40.9217 28.4277 40.2771 28.901 40.0617 29.632C39.8039 30.3631 40.0617 31.1366 40.7063 31.5674C42.3398 32.6837 43.8444 33.8015 44.9198 34.8344Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.373 37.5H51.8424",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8066 37.5H58.5469",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4768 68.7129H67.6211V72.8839H80.4768V68.7129Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3695 64.5859H69.5137V68.713H82.3695V64.5859Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9496 60.459H68.0938V64.586H80.9496V60.459Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4192 68.7129H22.6074V72.8839H35.4192V68.7129Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5266 64.5859H20.7148V68.713H33.5266V64.5859Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9414 72.8832V70.0469",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1562 72.8832V70.0469",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8965 72.8832V70.0469",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M80.002 68.7133V65.918",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M75.918 68.7133V65.918",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M78.584 64.5883V61.793",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8027 64.5883V61.793",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0527 72.8832V70.0469",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2695 72.8832V70.0469",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3359 68.7133V65.918",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M23.207 68.7133V65.918",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1777 72.9258V75.5907",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2655 14.498L70.6301 22.1939L78.282 21.8936V24.1293L71.4901 26.4938L68.2655 34.619L65.041 26.4938L58.2051 24.1293V21.8936L65.901 22.1939L68.2655 14.498Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1413 34.6621L31.0766 40.9823L37.3968 40.2512L36.966 42.4869L31.9366 44.4222L29.1413 51.1717L26.3474 44.4222L21.3604 42.4869L20.9297 40.2512L27.2074 40.9823L29.1413 34.6621Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2655 11.877L70.6301 19.5288L78.282 21.8949L70.6301 24.2595L68.2655 31.0954L65.901 24.2595L58.2051 21.8949L65.901 19.5288L68.2655 11.877Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1413 31.998L31.0766 38.3182L37.3968 40.2521L31.0766 42.1874L29.1413 47.6476L27.2074 42.1874L20.9297 40.2521L27.2074 38.3182L29.1413 31.998Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0391 26.4935V24.1289",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4473 26.578V23.998",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9355 44.4212V42.0566",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1387 50.8286V47.6465",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2656 34.6197V30.9219",
    stroke: "#171819",
    strokeWidth: 0.773834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralHowItWorksStep3);
export default __webpack_public_path__ + "static/media/referral-how-it-works-step-3.61ec9c979c4d99b783ed9554b4053910.svg";
export { ForwardRef as ReactComponent };